export const hasHTSConnectSupport = () => false;
